import { render, staticRenderFns } from "./desktop-course-drawer.vue?vue&type=template&id=03a1d845&scoped=true"
import script from "./desktop-course-drawer.vue?vue&type=script&lang=js"
export * from "./desktop-course-drawer.vue?vue&type=script&lang=js"
import style0 from "./desktop-course-drawer.vue?vue&type=style&index=0&id=03a1d845&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1d845",
  null
  
)

export default component.exports